import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('hajj_user') || sessionStorage.getItem('hajj_user'));
    } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password, role = 'admin', rememberMe = true) => {
    setLoading(true);
    try {
      const endpoint = role === 'admin' ? '/auth/admin/login' : '/auth/company/login';
      const { data } = await api.post(endpoint, { email, password });
      const storage = rememberMe ? localStorage : sessionStorage;
      storage.setItem('hajj_token', data.token);
      storage.setItem('hajj_user', JSON.stringify(data.user));
      setUser(data.user);
      return { success: true };
    } catch (err) {
      return { success: false, message: err.response?.data?.message || 'Login failed' };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('hajj_token');
    localStorage.removeItem('hajj_user');
    sessionStorage.removeItem('hajj_token');
    sessionStorage.removeItem('hajj_user');
    setUser(null);
  };

  const updateProfile = async (name, photo) => {
    try {
      const { data } = await api.put('/auth/profile', { name, photo });
      const updated = { ...user, name: data.user.name, photo: data.user.photo };
      localStorage.setItem('hajj_user', JSON.stringify(updated));
      setUser(updated);
      return { success: true };
    } catch (err) {
      return { success: false, message: err.response?.data?.message || 'Update failed' };
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateProfile, loading, isAdmin: user?.role === 'superadmin', isCompany: user?.role === 'company' }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
